module.exports = __webpack_public_path__ + "static/media/cat_sample.b51e2406.svg";